var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-download") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#484c52",
    d: "M27.281 27.892h-10.153l5.18-6.634c0.378-0.482 0.29-1.178-0.191-1.554-0.481-0.379-1.179-0.292-1.554 0.191l-3.456 4.427v-19.808c0-0.612-0.496-1.106-1.108-1.106s-1.108 0.495-1.108 1.106v19.807l-3.455-4.425c-0.378-0.484-1.074-0.569-1.556-0.191-0.482 0.377-0.567 1.072-0.191 1.554l5.18 6.634h-10.154c-0.612 0-1.106 0.496-1.106 1.108s0.495 1.108 1.106 1.108h22.564c0.612 0 1.108-0.496 1.108-1.108s-0.496-1.109-1.108-1.109z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.2be6416c.svg";
export { ForwardRef as ReactComponent };